export default __webpack_public_path__ + "static/media/1171.de7ce446.png";